// extracted by mini-css-extract-plugin
module.exports = {"pageholder":"ChangeFactor_pageholder__ypWiS","updateBtnHolder":"ChangeFactor_updateBtnHolder__2D2kZ","updateBtn":"ChangeFactor_updateBtn__2fZTT"};